import React from 'react';
import { isEmpty } from 'lodash';
import { Checkbox, Divider, FormControlLabel, FormGroup, Popover } from '@material-ui/core';
import { BUTTON, Button } from 'components/common/Button/Button';
import { getReportColumns, getReportDefaultColumns } from '../utils/reportUtils';
import styles from './PopoverCustomizeColumns.scss';

const PopoverCustomizeColumns = ({ reportType, anchorEl, customizeColumns, onClose, onSave }) => {
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const reportColumns = getReportColumns(reportType);
    let result = !isEmpty(customizeColumns) ? [...customizeColumns] : [];

    const handleCheckbox = event => {
        const { checked, value } = event.target;
        result = checked ? [...result, value] : result.filter(item => item !== value);
    };

    const handleSubmit = () => {
        if (isEmpty(result)) {
            result = getReportDefaultColumns(reportType);
        }
        onSave(result);
        onClose();
    };

    return (
        <Popover
            className={styles.customizeContainer}
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            {!isEmpty(customizeColumns) && (
                <div className={styles.customizeBody} data-cy="PopoverCustomizeColumns">
                    <FormGroup className={styles.customizeContent}>
                        {reportColumns.map(item => (
                            <FormControlLabel
                                key={item.key}
                                control={
                                    <Checkbox
                                        defaultChecked={customizeColumns.includes(item.key)}
                                        onChange={handleCheckbox}
                                    />
                                }
                                value={item.key}
                                label={item.label}
                            />
                        ))}
                    </FormGroup>
                    <Divider />
                    <div className={styles.customizeAction} data-cy="PopoverCustomizeColumnsSection">
                        <Button
                            onClick={onClose}
                            bgcolor={BUTTON.BGCOLOR.CLEAR}
                            color={BUTTON.COLOR.GREY}
                            outline={BUTTON.OUTCOLOR.LIGHTGREY}
                            data-cy="PopoverCustomizeColumns-Cancel"
                        >
                            Cancel
                        </Button>
                        <Button onClick={handleSubmit} bgcolor={BUTTON.BGCOLOR.ORANGE} 
                            color={BUTTON.COLOR.WHITE} data-cy="PopoverCustomizeColumns-Save">
                            Save
                        </Button>
                    </div>
                </div>
            )}
        </Popover>
    );
};

export default PopoverCustomizeColumns;
